import styled, { css } from 'styled-components';
import { newTableTokens } from '../../../tokens/components/NewTable/tokens';

import { colorTokens, elevationTokens } from '../../../tokens/globals/tokens';
import colors from '../../../assets/styled/colors';

import { setContrastColor } from './styles';

export type commonProps = {
  align?: 'left' | 'right';
  bgColor?: string;
  width?: string;
  whiteSpace?: 'normal' | 'nowrap';
};

const parseWidth = (width: string) => (Number.isInteger(Number(width)) ? `${width}px` : width);

const cellVariants = {
  'feedback-positive': newTableTokens.CellBackgroundColorPositiveDefault,
  'feedback-negative': newTableTokens.CellBackgroundColorNegativeDefault,
  'feedback-informational': newTableTokens.CellBackgroundColorInformationalDefault,
  'feedback-neutral': newTableTokens.CellBackgroundColorNeutralDefault,
};

const CoreCell = styled.td<React.TableHTMLAttributes<HTMLTableCellElement> & commonProps>`
  ${({ theme, onClick }) =>
    theme &&
    css`
      background-color: ${colors[theme.cellBgColor]};
      color: ${setContrastColor(colors[theme.cellBgColor])};
      text-align: ${theme.cellAlign === 'right' ? 'right' : 'left'};
      width: ${theme.cellWidthValue && parseWidth(theme.cellWidthValue)};
      min-width: ${theme.cellWidthValue && parseWidth(theme.cellWidthValue)};
      white-space: ${theme.cellWhiteSpace};
      cursor: ${onClick && 'pointer'};
      position: relative;

      ${({ theme }) =>
        theme.cellVariant &&
        css`
          background-color: ${cellVariants[theme.cellVariant]};
        `};

      ${({ theme }) =>
        theme.selectedRow &&
        css`
          background-color: ${newTableTokens.CellBackgroundColorBaseDown};
        `};

      ${({ theme }) =>
        theme.cellFreeze &&
        css`
          position: sticky;
          left: ${theme.cellOffsetLeft};
          z-index: ${elevationTokens.GlobalNewTableCellFrozen};
        `}

      // Left and right cell borders are created with box-shadow
      ${({ theme }) =>
        theme.cellDivider &&
        css`
          box-shadow: inset ${theme.cellDivider === 'right' ? '-1px' : '1px'} 0 ${colorTokens.GlobalBrandBlue70};
        `}
    `}
`;

export default CoreCell;
